import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ZustandStore } from "../../../store/zustand-store";
import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { getCountryFlag } from "../../../helperJs/getCountryFlag";
import globeImg from "../../Assets/rank-tracking-assets/www.svg";
import { useTranslation } from "react-i18next";

const ProjectLocation = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation()
  const [filter, setFilter] = useState("");

  const usercurrentprojectlocation = useSelector(
    (state) => state.usercurrentprojectlocation
  );
  const currentlocation = useSelector((state) => state.currentlocation);
  const {
    keyword_loc_data,
    keyword_latest_data,
    keyword_old_data,
    emptyKeywordData,
    emptyTagData,
  } = ZustandStore((state) => state);

  const locationList = useMemo(() => {
    if (!usercurrentprojectlocation?.length) return [];
    return usercurrentprojectlocation.reduce((acc, current) => {
      if (!acc.find((item) => item.location_code === current.location_code)) {
        acc.push(current);
      }
      return acc;
    }, []);
  }, [usercurrentprojectlocation]);

  const curr_location = currentlocation ? currentlocation : "Select a Location";

  const getCurrentCountryDetails = () => {
    return currentlocation === "All Locations"
      ? globeImg
      : getCountryFlag(currentlocation);
  };

  const dataWithFlags = useMemo(() => {
    const dataArr = locationList?.map((item) => ({
      ...item,
      location_flag: getCountryFlag(item?.location_name),
    }));
    return [
      {
        location_name: "All Locations",
        location_code: "All Locations",
        location_flag: globeImg,
      },
      ...dataArr,
    ];
  }, [locationList]);

  const options = useMemo(
    () =>
      dataWithFlags?.filter((value) => {
        return value?.location_name
          .toString()
          .toLowerCase()
          .includes(filter.toLowerCase());
      }),
    [filter, dataWithFlags]
  );

  const LocationHandler = (e) => {
    const selectedObj = options.find((option) => option.location_name === e);
    if (!selectedObj) return;
    if (
      selectedObj?.location_name === keyword_loc_data &&
      keyword_old_data?.length &&
      keyword_latest_data?.length
    ) {
      return;
    }
    emptyTagData();
    emptyKeywordData();
    dispatch({
      type: "CURRENTLOCATIONCODE",
      payload: selectedObj?.location_code,
    });
    dispatch({ type: "CURRENTLOCATION", payload: selectedObj?.location_name });
    ZustandStore.setState({
      selected_rank_data: {
        data: [],
        loaded: false,
      },
    });
  };

  return (
    <Flex direction="column">
      <Select
        placeholder={curr_location}
        value={curr_location}
        onChange={LocationHandler}
        w="100%"
        disabled={!currentlocation}
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: "35px",
          }}
          loading={!currentlocation}
        >
          {currentlocation && (
            <Select.Trigger.Addon>
              <img
                src={getCurrentCountryDetails()}
                alt="flag"
                style={{ width: "20px", objectFit: "contain" }}
                className="me-1"
              />
            </Select.Trigger.Addon>
          )}
          <Select.Trigger.Text>{curr_location || ""}</Select.Trigger.Text>
        </Select.Trigger>
        <Select.Popper aria-label={"Project options with search"}>
          <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            {options.map((value) => (
              <Select.Option
                value={value.location_name}
                key={value.location_name}
                style={{
                  boxShadow: "none",
                }}
              >
                <img
                  src={value.location_flag}
                  alt="flag"
                  style={{ width: "20px", objectFit: "contain" }}
                  className="me-1"
                />
                {value.location_name}
              </Select.Option>
            ))}
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length}  {t("opportunities.result")}{options.length > 1 && "s"} found
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                 {t("opportunities.nothing_found")}
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default ProjectLocation;
